import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

ReactDOM.render(<App />, document.getElementById('prime-number-visualizations'));

// var interestingWidths = [995, 600, 999, 1000, 1001, 1002, 998, 987, 573];
// var interestingWidths = [30, 186, 525, 210, 420];
